<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图">
    </div>
    <p class="title">苏州朗昱能源科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：苏州市高新区嘉陵江路198号数字文化产业园1号楼四楼414-1室</span>
      <!-- <span>Tel：888-888-888</span> -->
    </p>
    <p class="email_wx">
      <span>邮箱：service@routeflowcloud.com.cn</span>
      <!-- <span>微信号：xxx</span> -->
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 苏州朗昱能源科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #333333;
  /* background: #D5EBC9; */
  background: #ffffff;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #333333;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #333333;
  font-size: 14px;
}
.copy {
  color: #333333;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue